import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';
import { GAME_MODES } from '../../core/constats';

import { BigWinAnimationMobileDrawer } from './drawers/BigWinAnimationMobileDrawer';
import { BigWinAnimationDesktopDrawer } from './drawers/BigWinAnimationDesktopDrawer';

class BigWinAnimationDrawer extends BaseParentControlDrawer {
  execute(mode, { root }) {
    root.children = [];
    this.applications[mode].executeBigWinAnimation({ root });
  }
}

export const bigWinAnimationDrawer = new BigWinAnimationDrawer({
  [GAME_MODES.MOBILE]: new BigWinAnimationMobileDrawer(),
  [GAME_MODES.MOBILE_LANDSCAPE]: null,
  [GAME_MODES.DESKTOP]: new BigWinAnimationDesktopDrawer(),
});
